export default __webpack_public_path__ + "static/media/help.04dc11d1.svg";